webpackJsonp([6],{

/***/ 1116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsIncoming_vue__ = __webpack_require__(1269);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061ed570_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsIncoming_vue__ = __webpack_require__(1414);
function injectStyle (ssrContext) {
  __webpack_require__(1411)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-061ed570"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsIncoming_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061ed570_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsIncoming_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridTable_vue__ = __webpack_require__(1136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b00a312_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridTable_vue__ = __webpack_require__(1141);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b00a312_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'GridTable',
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: null
    },
    direction: {
      type: String,
      default: 'asc'
    },
    emptyText: {
      type: String,
      default: null
    },
    openId: {
      type: [String, Number],
      default: undefined
    },
    draggable: {
      type: Boolean,
      default: false
    },

    /**
     * Opt-in grouped drag mode (with `draggable`): [{ id, units: [{ row, children: [] }] }].
     * The row's `cell:*` slot decides who may be dragged by putting `gt__drag-handle--group`
     * (moves the whole group) or `gt__drag-handle--child` (reorders inside its own unit) on
     * the handle element. `rows` is then rendered below as plain, non-draggable rows.
     * Emits `drag-end` with the flat ordered ids of everything inside the groups.
     */
    groups: {
      type: Array,
      default: null
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    noBorders: {
      type: Boolean,
      default: false
    },
    noStripes: {
      type: Boolean,
      default: false
    },
    borderMode: {
      type: String,
      default: null
    },
    borderColor: {
      type: String,
      default: null
    },
    borderWidth: {
      type: String,
      default: null
    },
    rowBg: {
      type: String,
      default: null
    },
    tabAlignTop: {
      type: Boolean,
      default: false
    },
    mobBreak: {
      type: Number,
      default: 575
    },
    tabBreak: {
      type: Number,
      default: 767
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var root = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var isMob = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var isTab = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var internalOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var ro = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      ro = new ResizeObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];

        var w = entry.contentRect.width;
        isMob.value = w <= props.mobBreak;
        isTab.value = !isMob.value && w <= props.tabBreak;
      });
      ro.observe(root.value);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
      if (ro) ro.disconnect();
    });
    var cachedRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])([function () {
      return props.rows;
    }, function () {
      return props.loading;
    }], function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          rows = _ref4[0],
          loading = _ref4[1];

      if (!loading) cachedRows.value = rows;
    }, {
      immediate: true
    });
    var displayRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.loading ? cachedRows.value : props.rows;
    }); // Local mutable copy: vuedraggable splices the arrays it is given in place.

    var groupList = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.groups;
    }, function (groups) {
      groupList.value = (groups || []).map(function (group) {
        return _objectSpread({}, group, {
          units: group.units.map(function (unit) {
            return _objectSpread({}, unit, {
              children: _toConsumableArray(unit.children)
            });
          })
        });
      });
    }, {
      immediate: true
    }); // Row position across all groups, so stripes alternate row by row exactly like the plain table.

    var groupRowIndex = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var index = {};
      var n = 0;
      groupList.value.forEach(function (group) {
        return group.units.forEach(function (unit) {
          index[unit.row.id] = n++;
          unit.children.forEach(function (child) {
            index[child.id] = n++;
          });
        });
      });
      return index;
    });
    var groupRowCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Object.keys(groupRowIndex.value).length;
    }); // Second argument: the id of the row that was dragged (a group's first row, or the child row), so
    // the page can show the result of the reorder next to it.

    function onGroupDragEnd(evt) {
      var ids = groupList.value.flatMap(function (group) {
        return group.units.flatMap(function (unit) {
          return [unit.row.id].concat(_toConsumableArray(unit.children.map(function (child) {
            return child.id;
          })));
        });
      });
      var item = evt && evt.item;
      var holder = item && (item.dataset.rowId != null ? item : item.querySelector('[data-row-id]'));
      var movedId = holder ? Number(holder.dataset.rowId) : null;
      proxy.$emit('drag-end', ids, Number.isNaN(movedId) ? null : movedId);
    }

    var resolvedOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.openId !== undefined ? props.openId : internalOpenId.value;
    });

    function toggleRow(id) {
      if (props.openId !== undefined) return;
      internalOpenId.value = internalOpenId.value === id ? null : id;
    }

    function colTrack(col) {
      var widthKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width';
      var w = col[widthKey] || col.width || 'max-content';
      return col.minWidth ? "minmax(".concat(col.minWidth, ", ").concat(w, ")") : w;
    }

    var cssVars = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var vars = {
        '--gt-cols': props.columns.map(function (c) {
          return colTrack(c);
        }).join(' '),
        '--gt-cols-mob': props.columns.filter(function (c) {
          return !c.mobile;
        }).map(function (c) {
          return colTrack(c, 'mobileWidth');
        }).join(' '),
        '--gt-cols-tab': props.columns.filter(function (c) {
          return !c.tabRow && c.tablet !== 'hide' && c.tablet !== 'wrap';
        }).map(function (c) {
          return colTrack(c, 'tabWidth');
        }).join(' ')
      };
      if (props.borderColor != null) vars['--gt-border-color'] = props.borderColor;
      if (props.borderWidth != null) vars['--gt-border-width'] = props.borderWidth;
      if (props.rowBg != null) vars['--gt-row-bg'] = props.rowBg;
      return vars;
    });
    var mobileLabelCols = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.columns.filter(function (c) {
        return c.mobile === 'label';
      });
    });
    var primaryIdx = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var explicit = props.columns.findIndex(function (c) {
        return c.primary;
      });
      return explicit !== -1 ? explicit : props.columns.findIndex(function (c) {
        return !c.mobile;
      });
    });
    var hasExpand = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return 'expand' in proxy.$scopedSlots;
    });

    function mobClass(col) {
      if (!col.mobile) return null;
      return col.mobile === 'label' ? 'gt__cell--mob-label' : 'gt__cell--mob-hide';
    }

    function tabHdrClass(col) {
      if (col.tablet === 'wrap' || col.tabRow) return 'gt__hdr--tab-wrap';
      if (col.tablet === 'hide') return 'gt__hdr--tab-hide';
      if (col.tabHideLabel) return 'gt__hdr--tab-no-label';
      return null;
    }

    function tabCellClass(col) {
      if (col.tablet === 'wrap' || col.tabRow) return 'gt__cell--tab-wrap';
      if (col.tablet === 'hide') return 'gt__cell--tab-hide';
      return null;
    }

    var tabWrapLayout = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var n = props.columns.filter(function (c) {
        return !c.tabRow && c.tablet !== 'hide' && c.tablet !== 'wrap';
      }).length;

      function calcRow(cols, row) {
        return cols.reduce(function (acc, col, i, arr) {
          var prevEnd = i === 0 ? 1 : acc[arr[i - 1].key].end;
          var isLast = i === arr.length - 1;
          var pct = col.tabletWidth ? parseFloat(col.tabletWidth) / 100 : 1 / arr.length;
          var span = isLast ? n + 1 - prevEnd : Math.max(1, Math.round(pct * n));
          acc[col.key] = {
            start: prevEnd,
            end: prevEnd + span,
            row: row
          };
          return acc;
        }, {});
      }

      var rowNumbers = _toConsumableArray(new Set(props.columns.map(function (c) {
        return c.tablet === 'wrap' ? 2 : c.tabRow;
      }).filter(function (row) {
        return row != null;
      })));

      return rowNumbers.reduce(function (acc, row) {
        var cols = props.columns.filter(function (c) {
          return (c.tablet === 'wrap' ? 2 : c.tabRow) === row;
        });
        return _objectSpread({}, acc, {}, calcRow(cols, row));
      }, {});
    });

    function tabCellStyle(col) {
      var pos = tabWrapLayout.value[col.key];
      if (!pos) return {};
      return {
        '--tab-col-start': pos.start,
        '--tab-col-end': pos.end,
        '--tab-row': pos.row
      };
    }

    var borderModeClass = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!props.borderMode) return null;
      return "gt--border-".concat(props.borderMode);
    });
    return {
      root: root,
      isMob: isMob,
      isTab: isTab,
      displayRows: displayRows,
      groupList: groupList,
      groupRowIndex: groupRowIndex,
      groupRowCount: groupRowCount,
      onGroupDragEnd: onGroupDragEnd,
      resolvedOpenId: resolvedOpenId,
      toggleRow: toggleRow,
      cssVars: cssVars,
      mobileLabelCols: mobileLabelCols,
      primaryIdx: primaryIdx,
      hasExpand: hasExpand,
      mobClass: mobClass,
      tabHdrClass: tabHdrClass,
      tabCellClass: tabCellClass,
      tabCellStyle: tabCellStyle,
      borderModeClass: borderModeClass
    };
  }
}));

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormAlert__ = __webpack_require__(1127);
//
//
//
//
//
//
 // A message overlaid on the bottom of the row above (its parent must be a zero-height, relatively
// positioned anchor — GridTable's `before-row` slot is one), so it appears right over the row it is
// about without pushing the table apart. `alertKey` changes for every new message, even with the
// same text, so it re-appears. Click dismisses it.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RowAlert',
  components: {
    FormAlert: __WEBPACK_IMPORTED_MODULE_0__components_FormAlert__["a" /* default */]
  },
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'success'
    },
    alertKey: {
      type: [Number, String],
      default: 0
    },
    // The alert lives inside a (position: relative) table row instead of a zero-height anchor above
    // it: place its bottom edge on that row's top edge.
    aboveRow: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"gt",class:[{ 'gt--mob': _vm.isMob, 'gt--tab': _vm.isTab, 'gt--tab-top': _vm.tabAlignTop, 'gt--loading': _vm.loading, 'gt--no-borders': _vm.noBorders, 'gt--no-stripes': _vm.noStripes }, _vm.borderModeClass],style:(_vm.cssVars)},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),(!_vm.hideHeader)?_c('div',{staticClass:"gt__row gt__row--head"},_vm._l((_vm.columns),function(col){return _c('div',{key:col.key,staticClass:"gt__hdr",class:[_vm.mobClass(col), _vm.tabHdrClass(col), col.cellClass, { 'gt__hdr--sort': col.sortable }],on:{"click":function($event){col.sortable ? _vm.$emit('sort', col.key) : undefined}}},[_vm._v("\n      "+_vm._s(col.label)+"\n      "),(col.sortable)?_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.sort === col.key && _vm.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.sort === col.key && _vm.direction === 'desc' }]})]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.displayRows.length && !_vm.groupList.length)?_c('div',{staticClass:"gt__empty"},[_vm._v("\n    "+_vm._s(_vm.emptyText || 'No results found.')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.draggable && _vm.groups)?_c('draggable',{staticClass:"gt__draggable-body",attrs:{"tag":"div","list":_vm.groupList,"handle":".gt__drag-handle--group"},on:{"end":_vm.onGroupDragEnd}},_vm._l((_vm.groupList),function(group){return _c('div',{key:("g-" + (group.id)),staticClass:"gt__group",class:{ 'gt__group--single': group.units.length === 1 && !group.units[0].children.length }},[_vm._l((group.units),function(unit){return [(_vm.$scopedSlots['before-row'])?_c('div',{key:("before-" + (unit.row.id)),staticClass:"gt__before-row"},[_vm._t("before-row",null,{"row":unit.row})],2):_vm._e(),_vm._v(" "),_c('div',{key:String(unit.row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === unit.row.id, 'gt__row--odd': _vm.groupRowIndex[unit.row.id] % 2 === 0 },attrs:{"data-row-id":unit.row.id}},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(unit.row[col.key]))],{"row":unit.row}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(unit.row[mc.key]))],{"row":unit.row})],2)}),0):_vm._e()],2)}),0),_vm._v(" "),_c('draggable',{key:("u-" + (unit.row.id)),staticClass:"gt__draggable-body",attrs:{"tag":"div","list":unit.children,"group":("unit-" + (unit.row.id)),"handle":".gt__drag-handle--child"},on:{"end":_vm.onGroupDragEnd}},_vm._l((unit.children),function(child){return _c('div',{key:String(child.id),staticClass:"gt__row gt__row--data gt__row--child",class:{ 'gt__row--open': _vm.resolvedOpenId === child.id, 'gt__row--odd': _vm.groupRowIndex[child.id] % 2 === 0 },attrs:{"data-row-id":child.id}},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(child[col.key]))],{"row":child}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(child[mc.key]))],{"row":child})],2)}),0):_vm._e()],2)}),0)}),0)]})],2)}),0):_vm._e(),_vm._v(" "),(_vm.draggable && !_vm.groups)?_c('draggable',{staticClass:"gt__draggable-body",attrs:{"tag":"div","list":_vm.displayRows,"handle":".gt__drag-handle"},on:{"start":function($event){_vm.$emit('drag-start', _vm.displayRows.map(function (r) { return r.id; }))},"end":function($event){_vm.$emit('drag-end', _vm.displayRows.map(function (r) { return r.id; }))}}},_vm._l((_vm.displayRows),function(row,index){return _c('div',{key:String(row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === row.id, 'gt__row--odd': index % 2 === 0 }},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(row[col.key]))],{"row":row}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(row[mc.key]))],{"row":row})],2)}),0):_vm._e()],2)}),0)}),0):_vm._e(),_vm._v(" "),(!_vm.draggable || _vm.groups)?[_vm._l((_vm.displayRows),function(row,index){return [(_vm.$scopedSlots['before-row'])?_c('div',{key:("before-" + (row.id)),staticClass:"gt__before-row"},[_vm._t("before-row",null,{"row":row})],2):_vm._e(),_vm._v(" "),_c('div',{key:String(row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === row.id, 'gt__row--odd': (index + _vm.groupRowCount) % 2 === 0 }},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(row[col.key]))],{"row":row,"toggle":function () { return _vm.toggleRow(row.id); },"isOpen":_vm.resolvedOpenId === row.id}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(row[mc.key]))],{"row":row})],2)}),0):_vm._e()],2)}),0),_vm._v(" "),(_vm.hasExpand && _vm.resolvedOpenId === row.id)?_c('div',{key:("x-" + (row.id)),staticClass:"gt__expand"},[_vm._t("expand",null,{"row":row,"odd":(index + _vm.groupRowCount) % 2 === 0})],2):_vm._e()]})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowAlert_vue__ = __webpack_require__(1138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f28bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RowAlert_vue__ = __webpack_require__(1153);
function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69f28bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f28bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RowAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRowAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
 // The result of an action on one table row, shown right above that row (see RowAlert.vue) instead
// of at the top of the page. Auto-dismisses after 5s unless `persistent`; every call gets a new id
// so repeating an action with the same text re-creates the message and is visibly "new".

function useRowAlert() {
  var empty = function empty() {
    return {
      message: null,
      type: 'success',
      rowId: null,
      id: 0
    };
  };

  var alert = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(empty());
  var seq = 0;
  var timer = null;

  function clear() {
    clearTimeout(timer);
    alert.value = empty();
  }

  function show(message, type, rowId) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref$persistent = _ref.persistent,
        persistent = _ref$persistent === void 0 ? false : _ref$persistent;

    clearTimeout(timer);
    alert.value = {
      message: message,
      type: type,
      rowId: rowId,
      id: ++seq
    };
    if (!persistent) timer = setTimeout(clear, 5000);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
    return clearTimeout(timer);
  });
  return {
    alert: alert,
    show: show,
    clear: clear,
    showSuccess: function showSuccess(message, rowId) {
      return show(message, 'success', rowId);
    },
    showError: function showError(message, rowId, options) {
      return show(message, 'warning', rowId, options);
    }
  };
}

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("35f89dda", content, true, {});

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".row-alert[data-v-69f28bea]{position:absolute;right:0;bottom:0;left:0;height:0}.row-alert--above-row[data-v-69f28bea]{bottom:100%}.row-alert[data-v-69f28bea] .form-alert{position:absolute;right:8px;bottom:6px;left:8px}.row-alert[data-v-69f28bea] .alert{box-shadow:0 2px 8px rgba(0,0,0,.2)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/RowAlert.vue"],"names":[],"mappings":"AACA,4BACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,OAAQ,AACR,QAAU,CACX,AACD,uCACE,WAAa,CACd,AAID,wCACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,QAAU,CACX,AACD,mCACE,mCAAyC,CAC1C","file":"RowAlert.vue","sourcesContent":["\n.row-alert[data-v-69f28bea] {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 0;\n}\n.row-alert--above-row[data-v-69f28bea] {\n  bottom: 100%;\n}\n\n/* Absolute as well: while a new message replaces the old one (which is still fading out) the two\n   overlap in the same spot instead of stacking and shoving each other upwards. */\n.row-alert[data-v-69f28bea] .form-alert {\n  position: absolute;\n  right: 8px;\n  bottom: 6px;\n  left: 8px;\n}\n.row-alert[data-v-69f28bea] .alert {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"row-alert",class:{ 'row-alert--above-row': _vm.aboveRow }},[_c('form-alert',{key:_vm.alertKey,attrs:{"message":_vm.message,"type":_vm.type,"scroll-on-mount":"","flush":""},on:{"dismiss":function($event){return _vm.$emit('dismiss')}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getYears;
function getYears() {
  var currentYear = new Date().getFullYear();
  return Array.from({
    length: 6
  }, function (_, i) {
    return currentYear - i;
  });
}

/***/ }),

/***/ 1161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getIncoming: function getIncoming(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/incoming', {
      params: params
    });
  },
  getIncomingPdf: function getIncomingPdf(reportId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/reports/incoming/".concat(reportId, "/pdf"), {
      silent: true
    });
  },
  getOutgoingPdf: function getOutgoingPdf(reportId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/reports/outgoing/".concat(reportId, "/pdf"), {
      silent: true
    });
  },
  getIncomingTotals: function getIncomingTotals(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/incoming/totals', {
      params: params
    });
  },
  getOutgoing: function getOutgoing(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing', {
      params: params
    });
  },
  getOutgoingTotals: function getOutgoingTotals(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing/totals', {
      params: params
    });
  },
  getOutgoingOptions: function getOutgoingOptions() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing/options');
  },
  exportIncoming: function exportIncoming(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/incoming/export', {
      params: params,
      responseType: 'blob'
    });
  },
  exportOutgoing: function exportOutgoing(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing/export', {
      params: params,
      responseType: 'blob'
    });
  },
  updateIncomingAmount: function updateIncomingAmount(reportId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/reports/incoming/".concat(reportId, "/amount"), data, {
      silent: true,
      localSuccess: true
    });
  },
  updateOutgoingAmount: function updateOutgoingAmount(invoiceId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/reports/outgoing/invoices/".concat(invoiceId, "/amount"), data, {
      silent: true,
      localSuccess: true
    });
  },
  generateOutgoing: function generateOutgoing(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/reports/outgoing/generate"), data, {
      silent: true
    });
  },
  generationStatus: function generationStatus(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/reports/outgoing/generation-status"));
  },
  queueStatus: function queueStatus(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/reports/outgoing/queue-status"));
  },
  generateOutgoingAba: function generateOutgoingAba(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/reports/outgoing/aba', data, {
      silent: true,
      responseType: 'blob'
    });
  },
  updatePaymentType: function updatePaymentType(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/reports/outgoing/payment-type', data, {
      silent: true,
      localSuccess: true
    });
  },
  updatePaymentStatus: function updatePaymentStatus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/reports/outgoing/payment-status', data, {
      silent: true,
      localSuccess: true
    });
  },
  updateRefunds: function updateRefunds(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/reports/outgoing/refunds', data, {
      silent: true,
      localSuccess: true
    });
  },
  downloadVehiclesPdf: function downloadVehiclesPdf(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/reports/nominations-with-vehicles/pdf"), {
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reports_ReportsToggle__ = __webpack_require__(1222);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'ReportsFilterBar',
  components: {
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FSearchSelect__["a" /* default */],
    ReportsToggle: __WEBPACK_IMPORTED_MODULE_2__components_Reports_ReportsToggle__["a" /* default */]
  },
  props: {
    years: {
      type: Array,
      required: true
    },
    year: {
      default: null
    },
    drafts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    draftId: {
      default: null
    },
    draftsLoading: {
      type: Boolean,
      default: false
    },
    active: {
      type: String,
      default: 'incoming'
    }
  },
  computed: {
    draftSelectId: function draftSelectId() {
      return "".concat(this.active, "Draft");
    }
  }
}));

/***/ }),

/***/ 1189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'ReportsToggle',
  props: {
    active: {
      type: String,
      default: 'incoming'
    }
  }
}));

/***/ }),

/***/ 1190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'ReportsTotals',
  props: {
    totals: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    // Grand Total sums every bucket, including one with an empty/unassigned label (matches monolith:
    // app/View/Reports/outgoing.ctp sums before skipping the column render for an empty commit).
    var grandTotal = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.totals.reduce(function (sum, t) {
        return sum + parseFloat(t.amount || 0);
      }, 0).toFixed(2);
    });
    var visibleTotals = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.totals.filter(function (t) {
        return t.label;
      });
    });
    return {
      grandTotal: grandTotal,
      visibleTotals: visibleTotals
    };
  }
}));

/***/ }),

/***/ 1221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsFilterBar_vue__ = __webpack_require__(1188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1ef98c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsFilterBar_vue__ = __webpack_require__(1224);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsFilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1ef98c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsFilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsToggle_vue__ = __webpack_require__(1189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fd2be2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsToggle_vue__ = __webpack_require__(1223);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fd2be2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-2"},[_c('div',{staticClass:"filter"},[_c('div',{staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"reportsMode","id":"reportsModeIncoming","value":"incoming"},domProps:{"checked":_vm.active === 'incoming'},on:{"change":function($event){return _vm.$router.push({ path: '/reports/incoming', query: _vm.$route.query })}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"reportsModeIncoming"}},[_vm._v("Incoming money")])]),_vm._v(" "),_c('div',{staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"reportsMode","id":"reportsModeOutgoing","value":"outgoing"},domProps:{"checked":_vm.active === 'outgoing'},on:{"change":function($event){return _vm.$router.push({ path: '/reports/outgoing', query: _vm.$route.query })}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"reportsModeOutgoing"}},[_vm._v("Outgoing money")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-wrap mb-3"},[_c('div',{staticClass:"mr-3 mb-2 mb-md-0",staticStyle:{"min-width":"100px"}},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Filter by year")]),_vm._v(" "),_c('div',{staticStyle:{"max-width":"120px"}},[_c('f-search-select',{attrs:{"id":"reports_year","value":_vm.year,"options":_vm.years.map(function (y) { return ({ id: y, name: String(y) }); }),"searchable":false},on:{"input":function($event){_vm.$emit('year-change', Number($event))}}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"min-width":"200px"}},[_c('f-search-select',{attrs:{"id":_vm.draftSelectId,"label":"Drafts","options":_vm.drafts,"value":_vm.draftId,"disabled":_vm.draftsLoading || _vm.drafts.length === 0},on:{"input":function($event){return _vm.$emit('draft-change', $event)}}})],1)]),_vm._v(" "),_c('reports-toggle',{staticClass:"mb-3",attrs:{"active":_vm.active}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsTotals_vue__ = __webpack_require__(1190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360f9c8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsTotals_vue__ = __webpack_require__(1226);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsTotals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360f9c8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsTotals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered mb-0"},[_c('thead',[_c('tr',[_vm._l((_vm.visibleTotals),function(t){return _c('th',{key:t.label},[_vm._v(_vm._s(t.label))])}),_vm._v(" "),_c('th',[_vm._v("Grand Total")])],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_vm._l((_vm.visibleTotals),function(t){return _c('td',{key:t.label},[_vm._v(_vm._s(t.amount))])}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.grandTotal))])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReportsFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composables_useYears__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_committees__ = __webpack_require__(93);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useReportsFilter(router, onDraftReady) {
  var years = Object(__WEBPACK_IMPORTED_MODULE_1__composables_useYears__["a" /* default */])();
  var defaultYear = years[0];
  var state = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    years: years,
    year: defaultYear,
    drafts: [],
    draftId: null,
    draftsLoading: false
  });

  function buildQuery() {
    var q = {};
    if (state.year != null) q.year = String(state.year);
    if (state.draftId != null) q.draft_id = String(state.draftId);
    return q;
  }

  function pushQuery() {
    router.replace({
      query: buildQuery()
    }).catch(function () {});
  }

  function fetchDrafts() {
    return _fetchDrafts.apply(this, arguments);
  }

  function _fetchDrafts() {
    _fetchDrafts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state.year == null)) {
                _context.next = 3;
                break;
              }

              state.drafts = [];
              return _context.abrupt("return");

            case 3:
              state.draftsLoading = true;
              _context.prev = 4;
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_committees__["a" /* default */].drafts({
                year: state.year
              });

            case 7:
              res = _context.sent;
              state.drafts = (res.data.data != null ? res.data.data : []).map(function (d) {
                return {
                  id: d.id,
                  name: d.name
                };
              });
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              state.drafts = [];

            case 14:
              _context.prev = 14;
              state.draftsLoading = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 11, 14, 17]]);
    }));
    return _fetchDrafts.apply(this, arguments);
  }

  function setYear(val) {
    state.year = val;
    state.draftId = null;
    pushQuery();
    fetchDrafts();
  }

  function setDraft(val) {
    state.draftId = val;
    pushQuery();
    if (val != null && onDraftReady) onDraftReady();
  }

  function initFromQuery(_x) {
    return _initFromQuery.apply(this, arguments);
  }

  function _initFromQuery() {
    _initFromQuery = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(query) {
      var qYear, qDraft;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              qYear = query.year != null ? Number(query.year) : null;
              qDraft = query.draft_id != null ? Number(query.draft_id) : null;
              state.year = qYear != null ? qYear : defaultYear;
              _context2.next = 5;
              return fetchDrafts();

            case 5:
              if (qDraft != null && state.drafts.some(function (d) {
                return d.id === qDraft;
              })) {
                state.draftId = qDraft;
                if (onDraftReady) onDraftReady();
              }

              if (qYear == null) {
                pushQuery();
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _initFromQuery.apply(this, arguments);
  }

  return {
    state: state,
    setYear: setYear,
    setDraft: setDraft,
    initFromQuery: initFromQuery
  };
}

/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RowAlert__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_useRowAlert__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Reports_ReportsFilterBar__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reports_ReportsTotals__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__composables_reports_useReportsIncoming__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__composables_reports_useReportsFilter__ = __webpack_require__(1227);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var COMMIT_FILTERS = [{
  id: null,
  label: 'All'
}, {
  id: 'cash',
  label: 'Cash'
}, {
  id: 'direct',
  label: 'Direct deposits'
}, {
  id: 'cheque',
  label: 'Bank cheque'
}, {
  id: 'credit',
  label: 'Committee credit'
}, {
  id: 'eftpos',
  label: 'EFTPOS'
}];
var INCOMING_COLUMNS = [{
  key: 'date',
  label: 'Date received',
  sortable: true,
  primary: true,
  width: '1fr'
}, {
  key: 'invoiceNumber',
  label: 'Invoice number',
  sortable: true,
  mobile: 'label',
  width: '1fr'
}, {
  key: 'competitorName',
  label: 'Competitor name',
  sortable: true,
  mobile: 'label',
  width: '1.5fr'
}, {
  key: 'paymentType',
  label: 'Payment type',
  mobile: 'hide',
  width: '1fr'
}, {
  key: 'amount',
  label: 'Amount received',
  sortable: true,
  mobile: 'label',
  width: '1fr'
}];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'ReportsIncoming',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    GridTable: __WEBPACK_IMPORTED_MODULE_4__components_GridTable__["a" /* default */],
    RowAlert: __WEBPACK_IMPORTED_MODULE_5__components_RowAlert__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_7__components_Pagination__["a" /* default */],
    ReportsFilterBar: __WEBPACK_IMPORTED_MODULE_8__components_Reports_ReportsFilterBar__["a" /* default */],
    ReportsTotals: __WEBPACK_IMPORTED_MODULE_9__components_Reports_ReportsTotals__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var incoming = Object(__WEBPACK_IMPORTED_MODULE_10__composables_reports_useReportsIncoming__["a" /* default */])();
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var editingId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var editAmount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(''); // The result of saving an amount appears right above that row

    var rowAlert = Object(__WEBPACK_IMPORTED_MODULE_6__composables_useRowAlert__["a" /* default */])();

    function startEdit(row) {
      editingId.value = row.id;
      editAmount.value = row.amount != null ? row.amount : '';
    }

    function cancelEdit() {
      editingId.value = null;
      editAmount.value = '';
    }

    function saveAmount(_x) {
      return _saveAmount.apply(this, arguments);
    }

    function _saveAmount() {
      _saveAmount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(row) {
        var result, type;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return incoming.updateAmount(row.id, editAmount.value);

              case 2:
                result = _context.sent;
                editingId.value = null;
                editAmount.value = '';

                if (result) {
                  type = result.success ? 'success' : result.code === 'validation_error' ? 'danger' : 'warning';
                  rowAlert.show(result.message, type, row.id);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _saveAmount.apply(this, arguments);
    }

    var _useReportsFilter = Object(__WEBPACK_IMPORTED_MODULE_11__composables_reports_useReportsFilter__["a" /* default */])(proxy.$router, function () {
      incoming.filters.year = filterState.year;
      incoming.filters.draft_id = filterState.draftId;
      incoming.currentPage.value = 1;
      incoming.fetch();
      incoming.fetchTotals();
    }),
        filterState = _useReportsFilter.state,
        setYear = _useReportsFilter.setYear,
        setDraft = _useReportsFilter.setDraft,
        initFromQuery = _useReportsFilter.initFromQuery;

    function onYearChange(val) {
      setYear(val);
    }

    function onDraftChange(val) {
      setDraft(val);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      initFromQuery(proxy.$route.query);
    });
    return {
      filterState: filterState,
      items: incoming.items,
      totals: incoming.totals,
      loading: incoming.loading,
      filters: incoming.filters,
      currentPage: incoming.currentPage,
      lastPage: incoming.lastPage,
      setCommit: incoming.setCommit,
      setSearch: incoming.setSearch,
      resetSearch: incoming.resetSearch,
      setSort: incoming.setSort,
      setPage: incoming.setPage,
      updateAmount: incoming.updateAmount,
      exportReport: incoming.exportReport,
      exportingFormat: incoming.exportingFormat,
      generateReportPdf: incoming.generateReportPdf,
      generatingPdfIds: incoming.generatingPdfIds,
      searchInput: searchInput,
      editingId: editingId,
      editAmount: editAmount,
      rowAlert: rowAlert,
      startEdit: startEdit,
      cancelEdit: cancelEdit,
      saveAmount: saveAmount,
      onYearChange: onYearChange,
      onDraftChange: onDraftChange,
      commitFilters: COMMIT_FILTERS,
      incomingColumns: INCOMING_COLUMNS
    };
  }
}));

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1412);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("3fda6663", content, true, {});

/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".incoming-pdf-spinner[data-v-061ed570]{display:inline-block;width:12px;height:12px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;-webkit-animation:incoming-spin-data-v-061ed570 .7s linear infinite;animation:incoming-spin-data-v-061ed570 .7s linear infinite;flex-shrink:0}@-webkit-keyframes incoming-spin-data-v-061ed570{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes incoming-spin-data-v-061ed570{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Reports/ReportsIncoming.vue"],"names":[],"mappings":"AACA,uCACE,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,8BAA+B,AAC/B,6BAA8B,AAC9B,kBAAmB,AACnB,oEAAsE,AAC9D,4DAA8D,AACtE,aAAe,CAChB,AACD,iDACA,GAAK,gCAAkC,AAAC,uBAA0B,CACjE,CACA,AACD,yCACA,GAAK,gCAAkC,AAAC,uBAA0B,CACjE,CACA","file":"ReportsIncoming.vue","sourcesContent":["\n.incoming-pdf-spinner[data-v-061ed570] {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: incoming-spin-data-v-061ed570 0.7s linear infinite;\n          animation: incoming-spin-data-v-061ed570 0.7s linear infinite;\n  flex-shrink: 0;\n}\n@-webkit-keyframes incoming-spin-data-v-061ed570 {\nto { -webkit-transform: rotate(360deg); transform: rotate(360deg);\n}\n}\n@keyframes incoming-spin-data-v-061ed570 {\nto { -webkit-transform: rotate(360deg); transform: rotate(360deg);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReportsIncoming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_reports__ = __webpack_require__(1161);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function buildFilterParams(filters) {
  var params = {};
  if (filters.year != null) params.year = filters.year;
  if (filters.draft_id != null) params.draft_id = filters.draft_id;
  if (filters.commit) params.commit = filters.commit;
  if (filters.search) params.search = filters.search;
  return params;
}

function useReportsIncoming() {
  var items = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var totals = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var currentPage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var lastPage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var total = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
  var filters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    year: null,
    draft_id: null,
    commit: null,
    search: '',
    sort: 'date',
    direction: 'desc'
  });

  function fetchTotals() {
    return _fetchTotals.apply(this, arguments);
  }

  function _fetchTotals() {
    _fetchTotals = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var params, res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {};
              if (filters.year != null) params.year = filters.year;
              if (filters.draft_id != null) params.draft_id = filters.draft_id;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_reports__["a" /* default */].getIncomingTotals(params);

            case 6:
              res = _context.sent;
              data = res.data.data != null ? res.data.data : {};
              totals.value = Object.keys(data).map(function (key) {
                return {
                  label: key,
                  amount: parseFloat(data[key] || 0).toFixed(2)
                };
              });
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              totals.value = [];

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));
    return _fetchTotals.apply(this, arguments);
  }

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var params, res, list, meta;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              loading.value = true;
              _context2.prev = 1;
              params = _objectSpread({}, buildFilterParams(filters), {
                page: currentPage.value
              });

              if (filters.sort) {
                params.sort = filters.sort;
                params.direction = filters.direction;
              }

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_reports__["a" /* default */].getIncoming(params);

            case 6:
              res = _context2.sent;
              list = res.data.data != null ? res.data.data : [];
              items.value = list.map(function (r) {
                return {
                  id: r.id,
                  date: r.created_at,
                  invoiceNumber: r.invoice_number || '',
                  pdfUrl: r.pdf_url || null,
                  competitorName: r.user != null ? "".concat(r.user.first_name, " ").concat(r.user.last_name) : '',
                  paymentType: r.commit != null ? r.commit : '',
                  amount: r.amount
                };
              });
              meta = res.data.meta != null ? res.data.meta : {};
              currentPage.value = meta.current_page != null ? meta.current_page : 1;
              lastPage.value = meta.last_page != null ? meta.last_page : 1;
              total.value = meta.total != null ? meta.total : 0;
              _context2.next = 17;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](1);

            case 17:
              _context2.prev = 17;
              loading.value = false;
              return _context2.finish(17);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 15, 17, 20]]);
    }));
    return _fetch.apply(this, arguments);
  }

  function setCommit(commit) {
    filters.commit = commit;
    currentPage.value = 1;
    fetch();
  }

  function setSearch(val) {
    filters.search = val;
    currentPage.value = 1;
    fetch();
  }

  function resetSearch() {
    filters.search = '';
    currentPage.value = 1;
    fetch();
  }

  function setSort(field) {
    if (filters.sort === field) {
      filters.direction = filters.direction === 'asc' ? 'desc' : 'asc';
    } else {
      filters.sort = field;
      filters.direction = 'asc';
    }

    fetch();
  }

  function setPage(page) {
    currentPage.value = page;
    fetch();
  }

  function updateAmount(_x, _x2) {
    return _updateAmount.apply(this, arguments);
  }

  function _updateAmount() {
    _updateAmount = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(reportId, amount) {
      var res, resp;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_reports__["a" /* default */].updateIncomingAmount(reportId, {
                amount: amount
              });

            case 3:
              res = _context3.sent;
              _context3.next = 6;
              return fetch();

            case 6:
              _context3.next = 8;
              return fetchTotals();

            case 8:
              return _context3.abrupt("return", {
                success: true,
                message: res.data.message != null ? res.data.message : 'Amount updated.'
              });

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              resp = _context3.t0.response && _context3.t0.response.data ? _context3.t0.response.data : {};
              return _context3.abrupt("return", {
                success: false,
                message: resp.message != null ? resp.message : 'An error occurred.',
                code: resp.code
              });

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));
    return _updateAmount.apply(this, arguments);
  }

  var exportingFormat = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

  function exportReport(_x3) {
    return _exportReport.apply(this, arguments);
  }

  function _exportReport() {
    _exportReport = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(format) {
      var params, res, blobUrl, disposition, filename, match, url, link;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(exportingFormat.value != null)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              exportingFormat.value = format;
              _context4.prev = 3;
              params = _objectSpread({}, buildFilterParams(filters), {
                format: format
              });

              if (filters.sort) {
                params.sort = filters.sort;
                params.direction = filters.direction;
              }

              _context4.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_reports__["a" /* default */].exportIncoming(params);

            case 8:
              res = _context4.sent;

              if (!(format === 'pdf')) {
                _context4.next = 13;
                break;
              }

              blobUrl = URL.createObjectURL(new Blob([res.data], {
                type: 'application/pdf'
              }));
              window.open(blobUrl, '_blank');
              return _context4.abrupt("return");

            case 13:
              disposition = res.headers['content-disposition'];
              filename = "reports-incoming.".concat(format);

              if (disposition) {
                match = disposition.match(/filename="?([^"]+)"?/);
                if (match) filename = match[1];
              }

              url = URL.createObjectURL(new Blob([res.data]));
              link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              _context4.next = 28;
              break;

            case 26:
              _context4.prev = 26;
              _context4.t0 = _context4["catch"](3);

            case 28:
              _context4.prev = 28;
              exportingFormat.value = null;
              return _context4.finish(28);

            case 31:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 26, 28, 31]]);
    }));
    return _exportReport.apply(this, arguments);
  }

  var generatingPdfIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(new Set());

  function generateReportPdf(_x4) {
    return _generateReportPdf.apply(this, arguments);
  }

  function _generateReportPdf() {
    _generateReportPdf = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(reportId) {
      var res, url, item, next;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!generatingPdfIds.value.has(reportId)) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              generatingPdfIds.value = new Set([].concat(_toConsumableArray(generatingPdfIds.value), [reportId]));
              _context5.prev = 3;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_reports__["a" /* default */].getIncomingPdf(reportId);

            case 6:
              res = _context5.sent;
              url = res.data.data.url;

              if (url) {
                _context5.next = 10;
                break;
              }

              return _context5.abrupt("return");

            case 10:
              window.open(url, '_blank');
              item = items.value.find(function (i) {
                return i.id === reportId;
              });
              if (item) item.pdfUrl = url;
              _context5.next = 17;
              break;

            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](3);

            case 17:
              _context5.prev = 17;
              next = new Set(generatingPdfIds.value);
              next.delete(reportId);
              generatingPdfIds.value = next;
              return _context5.finish(17);

            case 22:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 15, 17, 22]]);
    }));
    return _generateReportPdf.apply(this, arguments);
  }

  return {
    items: items,
    totals: totals,
    loading: loading,
    filters: filters,
    currentPage: currentPage,
    lastPage: lastPage,
    total: total,
    fetch: fetch,
    fetchTotals: fetchTotals,
    setCommit: setCommit,
    setSearch: setSearch,
    resetSearch: resetSearch,
    setSort: setSort,
    setPage: setPage,
    updateAmount: updateAmount,
    exportReport: exportReport,
    exportingFormat: exportingFormat,
    generateReportPdf: generateReportPdf,
    generatingPdfIds: generatingPdfIds
  };
}

/***/ }),

/***/ 1414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Reports")]),_vm._v(" "),_c('reports-filter-bar',{attrs:{"years":_vm.filterState.years,"year":_vm.filterState.year,"drafts":_vm.filterState.drafts,"draft-id":_vm.filterState.draftId,"drafts-loading":_vm.filterState.draftsLoading,"active":"incoming"},on:{"year-change":_vm.onYearChange,"draft-change":_vm.onDraftChange}}),_vm._v(" "),(_vm.filterState.draftId != null)?[_c('div',{staticClass:"d-flex flex-wrap align-items-end mb-3"},[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-2 mr-3"},[_c('div',{staticClass:"filter"},_vm._l((_vm.commitFilters),function(t){return _c('div',{key:t.id,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":'paymentFilter',"id":'paymentFilter_' + t.id},domProps:{"value":t.id,"checked":_vm.filters.commit === t.id},on:{"change":function($event){return _vm.setCommit(t.id)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'paymentFilter_' + t.id}},[_vm._v(_vm._s(t.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group ml-auto mb-2"},[_c('div',{staticClass:"input-append d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0",staticStyle:{"min-width":"180px"},attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setSearch(_vm.searchInput)},"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('div',{staticClass:"form-check pl-2 mb-0"},[_c('input',{staticClass:"form-check-input",staticStyle:{"display":"none"},attrs:{"type":"radio","id":"searchBtn"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label font-weight-normal",staticStyle:{"cursor":"pointer"},attrs:{"for":"searchBtn"},on:{"click":function($event){return _vm.setSearch(_vm.searchInput)}}},[_vm._v("Search")])]),_vm._v(" "),_c('div',{staticClass:"form-check pl-2 mb-0"},[_c('input',{staticClass:"form-check-input",staticStyle:{"display":"none"},attrs:{"type":"radio","id":"resetBtn"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label font-weight-normal",staticStyle:{"cursor":"pointer"},attrs:{"for":"resetBtn"},on:{"click":function($event){_vm.searchInput = ''; _vm.resetSearch()}}},[_vm._v("Reset")])])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex mb-3"},[_c('app-button',{staticClass:"mr-2",attrs:{"variant":"outline-primary","size":"sm","block":false,"loading":_vm.exportingFormat === 'pdf',"disabled":_vm.exportingFormat != null},on:{"click":function($event){return _vm.exportReport('pdf')}}},[_vm._v("Download PDF")]),_vm._v(" "),_c('app-button',{attrs:{"variant":"outline-primary","size":"sm","block":false,"loading":_vm.exportingFormat === 'csv',"disabled":_vm.exportingFormat != null},on:{"click":function($event){return _vm.exportReport('csv')}}},[_vm._v("Download CSV")])],1),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"300px"}},[_c('grid-table',{attrs:{"columns":_vm.incomingColumns,"rows":_vm.items,"loading":_vm.loading,"sort":_vm.filters.sort,"direction":_vm.filters.direction},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"before-row",fn:function(ref){
var row = ref.row;
return [(_vm.rowAlert.alert.value.message && _vm.rowAlert.alert.value.rowId === row.id)?_c('row-alert',{attrs:{"message":_vm.rowAlert.alert.value.message,"type":_vm.rowAlert.alert.value.type,"alert-key":_vm.rowAlert.alert.value.id},on:{"dismiss":function($event){return _vm.rowAlert.clear()}}}):_vm._e()]}},{key:"cell:invoiceNumber",fn:function(ref){
var row = ref.row;
return [(row.pdfUrl)?_c('a',{staticClass:"text-primary",attrs:{"href":row.pdfUrl,"target":"_blank","rel":"noopener"}},[_vm._v("#"+_vm._s(row.invoiceNumber))]):(_vm.generatingPdfIds.has(row.id))?_c('span',{staticClass:"d-inline-flex align-items-center text-muted",staticStyle:{"gap":"5px"}},[_c('span',{staticClass:"incoming-pdf-spinner"}),_vm._v("#"+_vm._s(row.invoiceNumber)+"\n            ")]):_c('a',{staticClass:"text-muted",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.generateReportPdf(row.id)}}},[_vm._v("#"+_vm._s(row.invoiceNumber))])]}},{key:"cell:amount",fn:function(ref){
var row = ref.row;
return [(_vm.editingId !== row.id)?_c('div',{staticStyle:{"display":"flex","width":"100%","justify-content":"space-between","align-items":"center"}},[_c('span',[_vm._v(_vm._s(row.amount))]),_vm._v(" "),_c('a',{staticClass:"icon-btn icon-btn--edit",attrs:{"href":"#","title":"Edit amount"},on:{"click":function($event){$event.preventDefault();return _vm.startEdit(row)}}})]):_c('div',{staticClass:"input-append d-flex align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAmount),expression:"editAmount"}],staticClass:"form-control flex-grow-1",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(_vm.editAmount)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.saveAmount(row)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelEdit($event)}],"input":function($event){if($event.target.composing){ return; }_vm.editAmount=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary flex-shrink-0 ml-2",on:{"click":function($event){return _vm.saveAmount(row)}}},[_vm._v("Save")])])]}}],null,false,485882553)})],1),_vm._v(" "),_c('reports-totals',{staticClass:"mt-3",attrs:{"totals":_vm.totals}}),_vm._v(" "),_c('pagination',{staticClass:"mt-3",attrs:{"total-pages":_vm.lastPage,"page":_vm.currentPage,"on-change":_vm.setPage}})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.da11b62a9045b4a5d6c6.js